import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';

export const getQuizzesAsDataTable: ApiMethod<
  Server.QuizDatatableInput,
  Server.TableOfQuizColumns,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Quizzes_Client(undefined, contentClient);

    const response = await client.admin_Quizzes_datatable_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const createNewQuiz: ApiMethod<
  Server.CreateQuizInput,
  number,
  any
> = async (variables, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Quizzes_Client(undefined, contentClient);

    const response = await client.admin_Quizzes_create_post_V1(variables);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const editQuiz: ApiMethod<Server.EditQuizInput, void, any> = async (
  variables,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Quizzes_Client(undefined, contentClient);

    const response = await client.admin_Quizzes_edit_put_V1(variables);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

// export const changeQuizPublishState: ApiMethod<
//   Server.QuizPublicationInput,
//   void,
//   any
// > = async (variables, { dispatch, rejectWithValue }) => {
//   try {
//     const client = new Server.Server_Quizzes_Client(undefined, contentClient);

//     const response = await client.admin_Quizzes_publishState_put_V1(variables);

//     if (response.success) {
//       return;
//     }

//     return rejectWithValue(response.errors);
//   } catch (error: any) {
//     const errors = JSON.parse(error.response).errors;

//     dispatch(
//       CommonActions.setAlert({
//         type: AlertType.WARNING,
//         messages: errors || [{ message: 'Something went wrong' }],
//       })
//     );

//     return rejectWithValue(error);
//   }
// };
